// ACC-523: shared keyframes for skeleton/loading affordances, replacing the
// Tailwind `animate-pulse` / `animate-spin` utilities used across ticketing.
import {keyframes} from 'styled-components';

export const pulse = keyframes`
	0%, 100% { opacity: 1; }
	50% { opacity: 0.5; }
`;

export const spin = keyframes`
	to { transform: rotate(360deg); }
`;
